/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { jsx } from '@atlaskit/css';
import { EditorContext } from '@atlaskit/editor-core/editor-context';
import InlineEdit from '@atlaskit/inline-edit';
import { Box } from '@atlaskit/primitives/compiled';

import { useEditorPreset } from '../../fields/editor/useEditorPreset';

import { RichTextEditor } from './RichTextEditor';
import { PreviewSection } from './Section';

export const InlineEditorSection = ({
	title,
	placeholder,
	value,
	onConfirm,
	isDisabled = false,
}: {
	title: string;
	placeholder: string;
	value: string;
	onConfirm: (value: string) => void;
	isDisabled?: boolean;
}): JSX.Element => {
	const { editorApi, preset } = useEditorPreset(placeholder);

	if (isDisabled) {
		return (
			<PreviewSection title={title}>
				<EditorContext>
					<RichTextEditor value={value} preset={preset} disabled />
				</EditorContext>
			</PreviewSection>
		);
	}

	return (
		<PreviewSection title={title}>
			<EditorContext>
				<InlineEdit<string>
					readViewFitContainerWidth
					defaultValue={value}
					keepEditViewOpenOnBlur={false}
					editView={(fieldProps, ref) => (
						<Box ref={ref}>
							<RichTextEditor
								value={value}
								preset={preset}
								editorApi={editorApi}
								shouldFocus
								onChange={fieldProps.onChange}
							/>
						</Box>
					)}
					readView={() => <RichTextEditor value={value} preset={preset} />}
					onConfirm={onConfirm}
				/>
			</EditorContext>
		</PreviewSection>
	);
};
